// Generated on 2026-09-10T22:57:39.173Z
// This file contains preloaded top vehicle data from the API
// Do not edit manually - use 'npm run generate:top-vehicles-data' to regenerate

export const preloadedTopVehicles: any = [
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "151517"
  },
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "147832"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "134297"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "110777"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "96823"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "44553"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "42452"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "35593"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "34189"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "30119"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "28817"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "27914"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "25355"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "20322"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "19262"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "19098"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "16874"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "16741"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "16443"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "15479"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "14112"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "13503"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "13258"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "12598"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "12353"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "11862"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "11569"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "11137"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "10843"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "10684"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "10362"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "10089"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "10088"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "9875"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "7655"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "7529"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "7526"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "7447"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "7180"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "6905"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "6712"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "5925"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "5860"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "5589"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "5418"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "4945"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "4783"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "4501"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "4417"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "4290"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "4198"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "4174"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "4138"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "4065"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "3999"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "3921"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "3889"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "3842"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "3815"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "3740"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "3503"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "3377"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "3257"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "3241"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "3163"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "2868"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "2787"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "2751"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "2743"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "2689"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "2674"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "2662"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "2617"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "2590"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "2555"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "2551"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "2544"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "2447"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "2401"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "2295"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "2288"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "2215"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "2198"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "2159"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "2150"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "2094"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "2056"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "2031"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "2003"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "2001"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "1924"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "1924"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "1888"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "1883"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "1828"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "1775"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "1774"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "1637"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "1582"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "1559"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "1511"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "1488"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "1485"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "1466"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "1307"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "1278"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "1238"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "1216"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "1209"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "1178"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "1169"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "1149"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "1141"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "1075"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "1065"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "1026"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "1026"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "1018"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "983"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "964"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "952"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "948"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "934"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "910"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "906"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "901"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "896"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "891"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "842"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "812"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "807"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "800"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "772"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "770"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "768"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "752"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "752"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "745"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "730"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "728"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "712"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "696"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "693"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "678"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "661"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "615"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "612"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "601"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "601"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "594"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "581"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "580"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "574"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "573"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "573"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "568"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "557"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "554"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "552"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "538"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "533"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "525"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "524"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "519"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "509"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "508"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "505"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "500"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "497"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "483"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "474"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "467"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "464"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "451"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "447"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "431"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "431"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "426"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "426"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "407"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "396"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "389"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "384"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "382"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "379"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "378"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "373"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "371"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "368"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "367"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "365"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "364"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "362"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ALTO",
    "busquedas": "362"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "361"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "357"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "353"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "340"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "338"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "335"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "326"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "320"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "319"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "319"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "311"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "308"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "304"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "301"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "298"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "291"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "276"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "272"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "272"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "270"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "267"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "267"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "266"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "265"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "257"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "256"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "252"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "249"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "238"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "237"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "237"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "234"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "233"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "230"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "230"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "228"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "224"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "224"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "223"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "222"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "217"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "217"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "213"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "213"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "208"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "204"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "204"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "202"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "201"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "200"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "199"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "197"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "196"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "196"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "190"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "189"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "187"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "186"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "182"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "174"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "173"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "171"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "169"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "168"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "163"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "158"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "158"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "157"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "153"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "150"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "147"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "146"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "145"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "144"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "135"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "134"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "133"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "132"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "131"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "129"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "129"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "127"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "127"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "126"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "124"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "122"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "119"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "119"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "118"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "117"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "115"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "113"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "113"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "112"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "111"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "110"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "110"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "108"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "105"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "103"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "103"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "103"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "102"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "102"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "98"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "96"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "96"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "96"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "96"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "94"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "92"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "92"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "92"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "92"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "90"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "89"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "89"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "89"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "89"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "88"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "88"
  },
  {
    "marca": "FORD",
    "modelo": "EVEREST",
    "busquedas": "87"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "87"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "86"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "86"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "85"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "85"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "84"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "83"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "81"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "81"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "80"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "80"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "80"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "80"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "80"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "79"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "79"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "78"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "76"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "76"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "75"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "74"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "74"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "74"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "73"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "72"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "71"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "71"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "70"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "70"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "70"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "69"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "67"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "67"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "66"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "65"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "63"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "63"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "62"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "61"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "61"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "61"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "60"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "60"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "60"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "60"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "60"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "59"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "58"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "57"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "56"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "54"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "54"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "53"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "53"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "52"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "52"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "52"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "52"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "51"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "51"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "51"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "51"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "51"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "51"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "50"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "49"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "49"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "49"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "48"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "48"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "48"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "48"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "48"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "47"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "47"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "46"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "46"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "45"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "45"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "45"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "44"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "44"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "44"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "43"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "43"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "43"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "42"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "42"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "42"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "41"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "40"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "40"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "40"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "39"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "39"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "39"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "39"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "38"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "38"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "38"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "38"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "38"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "37"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "37"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "37"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "37"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "37"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "37"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "37"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "36"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "36"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "36"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "36"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "35"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "35"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "35"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "35"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "34"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "34"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CARRY",
    "busquedas": "34"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "34"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "33"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "33"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "32"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "32"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 50",
    "busquedas": "32"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "32"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "32"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "32"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "30"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "30"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "30"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "29"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "29"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "29"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "29"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "28"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "27"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "27"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "27"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "26"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "26"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "26"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "26"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "25"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "25"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "25"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "25"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "25"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "24"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC DEL SOL",
    "busquedas": "24"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "24"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "24"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "24"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "24"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "24"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "24"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "24"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "24"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "24"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "24"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "23"
  },
  {
    "marca": "SCION",
    "modelo": "IM",
    "busquedas": "23"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "23"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "23"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "23"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "22"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "22"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "22"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "22"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "22"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "21"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "21"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "21"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "21"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "21"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "20"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR",
    "busquedas": "20"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "20"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "20"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "19"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "19"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "E-COUNTY",
    "busquedas": "18"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "18"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "18"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "17"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "17"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "17"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "17"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "17"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "17"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "17"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "17"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "17"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "16"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "BMW",
    "modelo": "740I",
    "busquedas": "16"
  },
  {
    "marca": "ZNA",
    "modelo": "RICH 6",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "16"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "16"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "15"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "15"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "15"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "15"
  },
  {
    "marca": "KIA",
    "modelo": "PRIDE",
    "busquedas": "14"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "14"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "14"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "13"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "13"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ERTIGA",
    "busquedas": "13"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "13"
  },
  {
    "marca": "BMW",
    "modelo": "335I XDRIVE",
    "busquedas": "13"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "13"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "13"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS200",
    "busquedas": "12"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "12"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ROUTAN",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "12"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "XPANDER CROSS",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "FESTIVA",
    "busquedas": "12"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "11"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "11"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "11"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "11"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "11"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "11"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "10"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "10"
  },
  {
    "marca": "AUDI",
    "modelo": "A6",
    "busquedas": "10"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "10"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "KONA",
    "busquedas": "10"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "10"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "10"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "LS",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "10"
  },
  {
    "marca": "PORSCHE",
    "modelo": "911",
    "busquedas": "9"
  },
  {
    "marca": "JMC",
    "modelo": "GRAND AVENUE",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK500",
    "busquedas": "9"
  },
  {
    "marca": "SUZUKI",
    "modelo": "DZIRE",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "9"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "9"
  },
  {
    "marca": "FOTON",
    "modelo": "TUNLAND",
    "busquedas": "9"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "8"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 HD",
    "busquedas": "8"
  },
  {
    "marca": "AUDI",
    "modelo": "A5 QUATTRO",
    "busquedas": "8"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "328D XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S350",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "325E",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "8"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "318TI",
    "busquedas": "8"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STARIA",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "7"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "7"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "300ZX",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS350",
    "busquedas": "7"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-370",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "7"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "7"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX400H",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "7"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "7"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "7"
  },
  {
    "marca": "SATURN",
    "modelo": "SW1",
    "busquedas": "7"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "7"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "6"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "6"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "6"
  },
  {
    "marca": "BMW",
    "modelo": "330I XDRIVE",
    "busquedas": "6"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "6"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "CROSSFIRE",
    "busquedas": "6"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "6"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CM10",
    "busquedas": "6"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA CRUZ",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "750I",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "GR86",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "550I XDRIVE",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "POLICE INTERCEPTOR UTILITY",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "5"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE53 AMG",
    "busquedas": "5"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CS15",
    "busquedas": "5"
  },
  {
    "marca": "AUDI",
    "modelo": "Q3",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500 SUBURBAN",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS PLAY",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL550",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "5"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "C-HR",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "5"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "5"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "NX",
    "busquedas": "4"
  },
  {
    "marca": "JAC",
    "modelo": "PICKUP",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "M2",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "DL",
    "busquedas": "4"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 3500",
    "busquedas": "4"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "4"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKZ",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XTS",
    "busquedas": "4"
  },
  {
    "marca": "JAC",
    "modelo": "T6",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "4"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "ASPEN",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "BUICK",
    "modelo": "LUCERNE",
    "busquedas": "4"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC40",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE450",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "228I",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "CIVILIAN",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE350",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML430",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK280",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "CJ7",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE L",
    "busquedas": "3"
  },
  {
    "marca": "CHANGAN",
    "modelo": "HUNTER",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "CROWN VICTORIA",
    "busquedas": "3"
  },
  {
    "marca": "ACURA",
    "modelo": "CL",
    "busquedas": "3"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES350",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "550I",
    "busquedas": "3"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIERO",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "3"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "SAAB",
    "modelo": "9-3",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "929",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "B9 TRIBECA",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "JUSTY",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "LOYALE",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "3"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 3500",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 1500",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 2500",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK320",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "3"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "530XI",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-TYPE",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "FIAT",
    "modelo": "BRAVA",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 2 PRO",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "340I XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "TOWNER",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CIAZ",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE LIMITED",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "K3",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF R",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV3500",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "190D",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SYCLONE",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S500",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "635CSI",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "TEMPO",
    "busquedas": "2"
  },
  {
    "marca": "ISUZU",
    "modelo": "IMPULSE",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "MONTANA",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "LIANA",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q70L",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "M45",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "M35",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIREBIRD",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "R20 SUBURBAN",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "CORDIA",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "535D XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "A5",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX550",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "A3 QUATTRO",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300SDL",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ETIOS",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER VELAR",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CL500",
    "busquedas": "2"
  },
  {
    "marca": "TESLA",
    "modelo": "S",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "MILAN",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "CAPRI",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "230I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "HUMMER",
    "modelo": "H1",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-PACE",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "V1500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "500X",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "228I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LANOS",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "I8",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER EXT",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "JS2",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "525IT",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "ISUZU",
    "modelo": "ASCENDER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 CLASSIC",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q40",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CATERA",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX45",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "G63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "RS4",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300E",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300CD",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "Y",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SJ410",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-CROSS",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "KIZASHI",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "K1500",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSICA",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "NAVAJO",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "500SEL",
    "busquedas": "1"
  },
  {
    "marca": "SSANGYONG",
    "modelo": "KORANDO",
    "busquedas": "1"
  },
  {
    "marca": "SMART",
    "modelo": "FORTWO",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-90",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L300",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L200",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D250",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUMINA",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D100",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "BUGATTI",
    "modelo": "CHIRON",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "FOTON",
    "modelo": "VIEW CS2",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C10 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "90 QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "EOS",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "SC430",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER CITY",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF SPORTWAGEN",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD CROSSTOUR",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "GRANADA",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CLARITY",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "R32",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "F-150 HERITAGE",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "VAN",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "GRAND CARNIVAL",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 CLUB WAGON",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE CLUB WAGON",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "MINIBUS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I GT",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C43 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CS35 PLUS",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  }
];

export default preloadedTopVehicles;
